import { css } from '@emotion/react';
import { type FC } from 'react';

import { Box } from '../Box';
import { StarRating } from '../StarRating';
import { Heading, Text } from '../Typography';
import ReviewItem, { type ReviewItemProps } from './components/ReviewItem';

export type ReviewsProps = {
  /**
   * Average rating value from 1 to 5
   */
  averageRating: number;
  /**
   * Total number of reviews
   */
  totalReviews: number;
  /**
   * Array of review items with labels and ratings
   */
  items: ReviewItemProps[];
  /**
   * Additional CSS class names
   */
  className?: string;
};

const Reviews: FC<ReviewsProps> = ({
  averageRating,
  totalReviews,
  items,
  className,
}) => {
  return (
    <Box
      width="100%"
      display="flex"
      flexDirection="column"
      alignItems="center"
      gap="var(--spacing-4)"
      backgroundColor="var(--surface-subtle)"
      borderRadius="var(--spacing-4)"
      p="var(--spacing-4)"
      className={className}
    >
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        gap="var(--spacing-2)"
      >
        <Heading size="sm" fontWeight="bold" color="text-primary">
          {averageRating.toFixed(1)}
        </Heading>
        <StarRating
          rating={averageRating}
          css={css`
            > svg {
              height: 40px;
              width: 40px;
            }
          `}
        />
        <Text size="sm" color="text-secondary">
          Overall Rating • {totalReviews} Review{totalReviews !== 1 ? 's' : ''}
        </Text>
      </Box>

      <Box
        display="flex"
        flexDirection="column"
        gap="var(--spacing-2)"
        width="100%"
      >
        {items.map((item, index) => (
          <ReviewItem key={index} label={item.label} rating={item.rating} />
        ))}
      </Box>
    </Box>
  );
};

export default Reviews;
